document.addEventListener("DOMContentLoaded", function (e) {
    const lists = e.target.querySelectorAll(".faq-header__termlist ul a[href^='#']");
    const contentDivs = e.target.querySelectorAll(".faq-page__list[data-category-slug]");

    if (lists.length > 0 && contentDivs.length > 0) {
        lists.forEach(link => {
            link.addEventListener("click", function (e) {
                e.preventDefault();
                const targetSlug = this.getAttribute("href").substring(1);
                const targetDiv = e.target.querySelector(`.faq-page__list[data-category-slug="${targetSlug}"]`);

                if (targetDiv) {
                    const targetPosition = targetDiv.getBoundingClientRect().top + window.pageYOffset;
                    window.scrollTo({
                        top: targetPosition - 20,
                        behavior: "smooth"
                    });
                }
            });
        });
    }
});

